module.exports = __webpack_public_path__ + "assets/retina_CircleInSquareDetailed.6abe2f4528ff246288552a35238995bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CircleInSquareDetailed.png
// module id = 642
// module chunks = 0